class Utils {
  static getDistanceFromTop(element) {
      const rect = element.getBoundingClientRect();
      const distanceFromTop = rect.top + window.scrollY;

      return distanceFromTop;
  }
}